import React, { useState, useEffect } from 'react';
import Icon from '../../../AppIcon';
import Button from '../../../ui/Button';

const LocationTracker = ({ onLocationUpdate, currentLocation }) => {
  const [isTracking, setIsTracking] = useState(false);
  const [accuracy, setAccuracy] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  useEffect(() => {
    if (currentLocation) {
      setLastUpdate(new Date()?.toLocaleTimeString());
    }
  }, [currentLocation]);

  const handleToggleTracking = () => {
    if (!isTracking) {
      // Simulate GPS tracking
      setIsTracking(true);
      const mockLocation = {
        latitude: 37.7749 + (Math.random() - 0.5) * 0.01,
        longitude: -122.4194 + (Math.random() - 0.5) * 0.01,
        accuracy: Math.floor(Math.random() * 10) + 5
      };
      setAccuracy(mockLocation?.accuracy);
      onLocationUpdate(mockLocation);
    } else {
      setIsTracking(false);
      setAccuracy(null);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-semibold text-foreground">Location Tracking</h3>
        <Button
          variant={isTracking ? "destructive" : "default"}
          size="sm"
          onClick={handleToggleTracking}
          iconName={isTracking ? "Square" : "Play"}
          iconSize={14}
        >
          {isTracking ? 'Stop' : 'Start'}
        </Button>
      </div>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <div className={`w-3 h-3 rounded-full ${isTracking ? 'bg-success animate-pulse' : 'bg-muted'}`}></div>
          <span className="text-sm text-muted-foreground">
            {isTracking ? 'Tracking active' : 'Tracking inactive'}
          </span>
        </div>
        
        {currentLocation && (
          <div className="space-y-2 text-sm">
            <div className="flex items-center space-x-2">
              <Icon name="MapPin" size={14} className="text-primary" />
              <span className="text-muted-foreground">
                {currentLocation?.latitude?.toFixed(6)}, {currentLocation?.longitude?.toFixed(6)}
              </span>
            </div>
            
            {accuracy && (
              <div className="flex items-center space-x-2">
                <Icon name="Target" size={14} className="text-accent" />
                <span className="text-muted-foreground">Accuracy: ±{accuracy}m</span>
              </div>
            )}
            
            {lastUpdate && (
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={14} className="text-warning" />
                <span className="text-muted-foreground">Last update: {lastUpdate}</span>
              </div>
            )}
          </div>
        )}
        
        <div className="pt-2 border-t border-border">
          <iframe
            width="100%"
            height="120"
            loading="lazy"
            title="Current Location"
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${currentLocation?.latitude || 37.7749},${currentLocation?.longitude || -122.4194}&z=15&output=embed`}
            className="rounded border border-border"
          />
        </div>
      </div>
    </div>
  );
};

export default LocationTracker;